import React from 'react'
import _ from 'lodash'
import pluralize from 'pluralize'
import '../../assets/css/pages/track_progress/struggling-area-row.css'
import { Link } from 'react-router-dom'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faExclamationCircle)

const StrugglingAreaRow = props => {
  const { studentCount, studentPercentage, dimensionItem, workProductType, quests } = props

  const workProductTypeText = {
    'Argument Builder':     'make an argument',
    'Research':             'evaluate relevant citations',
    'Heredity Probability': 'identify a probability',
    'Flowchart':            'create a flowchart'
  }

  // Display either the calculated percentage or "less than one percent"
  const displayPercentage = ()=>
    parseInt(studentPercentage*100) || "<1"

  return(
    <div className='struggling-area-row'>
      <span className='icon-column'>
        <FontAwesomeIcon icon='exclamation-circle'/>
      </span>
      <span>
        <div className='primary-text'>
          {pluralize('student', studentCount, true)}&nbsp;
          ({displayPercentage()}% of current group)&nbsp;
          {pluralize('is', studentCount)} struggling to
          <span className='sep'> {workProductTypeText[workProductType]} </span>for
          <span className='dci'> {dimensionItem}</span>.
        </div>
        <div className='subtext'>
          View Details: {_.map(quests, (quest, index) =>
            <span key={index}>
              <Link to={'track_progress/'+quest.id.toString()}>{quest.name}</Link>
              {index + 1 < quests.length ? <span>,&nbsp;</span> : ''}
            </span>
          )}
        </div>
      </span>
    </div>
  )
}

export default StrugglingAreaRow
